import React from "react";
import AgTechCloseIcon from "../../Icons/AgTechCloseIcon";
import { useDialogContext } from "@agtech/core/forms/dialogs/AgTechDialogs";
import { ErrorBoundary } from "react-error-boundary";

export type AgTechDialogProps = {
    width?: number
}

let AgTechDialog = (props: React.PropsWithChildren<AgTechDialogProps>) => {
    const dialogWidth = props.width ?? 400;

    return (
        <div
            className={`agtech-dialog`}
            style={{ width: dialogWidth }}
            onClick={e => e.stopPropagation()}
        >
            <AgTechDialogErrorBoundary>
                {props.children}
            </AgTechDialogErrorBoundary>
        </div>
    )
};

const AgTechDialogErrorBoundary = (props: {
    children: React.ReactNode
}) => {
    const dialogContext = useDialogContext();

    return (
        <ErrorBoundary
            fallbackRender={() => (
                <div className='stretched centered row-based relative flex'>
                    <AgTechCloseIcon
                        onClicked={async (e) => dialogContext.closeDialog(e)} 
                        classes="absolute top-[20px] right-[16px] z-10"
                        size={32}
                    />
                    <i className={`fas fa-exclamation bg-red-400 text-white mb-4 h-[32px] w-[32px] rounded-[50%] centered flex`} />
                    <h1 className='text-lg font-semibold mb-2' >An error occurred</h1>
                    <h2 className='text-plus'>Please close and open this dialog again</h2>
                </div>
            )}
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default AgTechDialog;